// extracted by mini-css-extract-plugin
module.exports = {"button":"NYThr","icon":"v6rop","theme_accessible":"GH5Gn"};